<template>
    <div class="our-call-center-view" data-sectionThemeDark="true">
        <return-menu />
        <!-- <responsive-burger-menu v-bind:MenuItems="MenuItems" /> -->
        <!-- home page view , each <section> must be a layout component -->
        <landing-intro-secondary v-bind:LandingIntroData="LandingIntroData" />    

        <section class="executive-summary section" data-sectionThemeDark="false">
            <div class="summary-container">
                <h2 class="section-heading --tert">Our Sales Team</h2>
                <p class="content-text">
                </p>
            </div>
            <div class="scroll-indicator-container">
            </div>
        </section>  

        <OurStars v-bind:OurStarsList="OurStarsList" />
        <contact-us v-bind="ContactUsData" />
        <FooterLayout />
    </div>
</template>

<script>
import ReturnMenu from '@/components/ui/ReturnMenu'
// import ResponsiveBurgerMenu from '@/components/ui/ResponsiveBurgerMenu'
import LandingIntroSecondary from '@/components/layout/LandingIntroSecondary'
import OurStars from '@/components/layout/OurStars'
import ContactUs from '@/components/layout/ContactUs'
import FooterLayout from '@/components/layout/Footer'
import SalesStarsJson from "@/assets/SalesStars.json";

export default {
    components: { ReturnMenu, LandingIntroSecondary, OurStars, ContactUs, FooterLayout },

    data() {
        return {
            LandingIntroData: {
                NameLocation: '#Home',
                BackgroundClass: '--sales-visual',
                HeadingText: '“I was so impressed with the staff and their excellent service! They kept me updated all the time and even called to see if the problem was sorted. Keep up the good service delivery!”',
                Speaker: null,
                Btn: '#keepingYouSafe',
                BtnState: false,
                ShowVideo: false
            },
            OurStarsList: SalesStarsJson,
            ContactUsData: [{
                NameLocation: 'ContactUs',
                items: ['Client Service', 'Finance', 'Resolutions', 'Procurement', 'Medical Desk']
            }],
        };
    },

    mounted() {
        console.log(this.OurStarsList);
    },
};
</script>

<style lang="scss"></style>
